(function () {
    'use strict';

    angular
        .module('app.courseHandicap')
        .constant('courseHandicapResolver', {
            data: getData
        });
  
    getData.$inject = ['Course', '$transition$', 'user'];
    function getData(Course, $transition$, user) {
        var params = $transition$.params(),
            individualId = params.individualId || user.id,
            facilityId = params.facilityId || -1,
            handicapPercent = params.handicapPercent || 100;

        return Course.getCourseHandicapInfo({ individualId: individualId, facilityId: facilityId, handicapPercent: handicapPercent }).$promise;
    }
})();